module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-prior-payment-d909871059ac4141e70e03c0545b466c.png";